export const PLATFORM_SUPREMA = "10"
export const PLATFORM_PPPOKER = "5"
export const PLATFORM_CACHETA = "12"